import {TAntdErrorFields} from 'shared/types/antd';

export const getInvalidFieldsFromForm = (errorFields: TAntdErrorFields) => errorFields
    ?.map(f => f.name)
    ?.flat();
